export default Object.freeze({
  /**
   * Status label for 'Open' booking
   * A booking is 'Open' when -
   * a) First created (by Client with manager privileges)
   * b) Accepted booking has Candidate removed from it
   * c) Tentative booking has been declined/rejected by Candidate
   * d) Pending booking has been approved (by Client with manager privileges)
   * e) Existing empty booking is extended
   */
  Open: 'Open',

  InProgress: 'In Progress',
  /**
   * Status label for confirmed booking
   * Booking will show as "Confirmed" when:
   * - Booking has had Candidate tentatively placed into it by a Client or Consultant AND Candidate has accepted it
   * - Booking has had Candidate placed into it by Consultant (BAU)
   */
  Confirmed: 'Confirmed',

  /**
   * Status label for bookings that needs confirmation from the client
   * Booking will show as "Pending" when:
   * - Booking has had Candidate tentatively placed into it by a Client or Consultant AND Candidate has not accepted it
   */
  Pending: 'Pending',

  /**
   * Status label for when a booking is first created by client contact without manager privileges
   * Booking will show as "Unapproved" when:
   * - Booking is first created (by Client without manager privileges)
   */
  Unapproved: 'Unapproved',

  Cancelled: 'Cancelled',
})
